import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useImperativeHandle, useState, forwardRef } from "react";
import { MdSaveAlt } from "react-icons/md";
import { FaLink, FaPlus } from "react-icons/fa";
import { IoQrCode } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import QRCode from "react-qr-code";
import axios from "axios";
import TableLoader from "../../../utils/TableLoader";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import { TbEdit } from "react-icons/tb";
import { BiSolidTrashAlt } from "react-icons/bi";
import WineListAdd from "./WineListAdd/WineListAdd";
import WineListEdit from "./WineListEdit/WineListEdit";
// import PaginationComponent from "../../../utils/PaginationComponent";

const WineListManagement = (props, ref) => {
  const { hasPermission } = props;
  const navigate = useNavigate();

  const frontendApiUrl = import.meta.env.VITE_FRONTEND_APP_URL;
  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  const { slug2, rest_slug2 } = useParams();

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const [page2, setPage2] = useState(1);
  const [rowsPerPage2, setRowsPerPage2] = useState(100);
  const [totalPages2, setTotalPages2] = useState(0);

  const [restaurentDetail, setRestaurentDetail] = useState();
  const [wineStockAvailable, setWineStockAvailable] = useState(true);
  const [userType, setUserType] = useState("");
  const [selectedWineListId, setSelectedWineListId] = useState(null);

  const [searchWine, setSearchWine] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchWine(value);
    // let searchTexts = JSON.parse(localStorage.getItem("searchTexts")) || {};

    // if (wineStockAvailable) {
    //   searchTexts["WineList Stock Text"] = value;
    // } else {
    //   searchTexts["WineList AllWines Text"] = value;
    // }

    // localStorage.setItem("searchTexts", JSON.stringify(searchTexts));
  };

  const [isLoading, setIsLoading] = useState({
    main: false,
    edit: false,
    save: false,
  });

  const [addWineList, setAddWineList] = useState(false);
  const [editWineList, setEditWineList] = useState(false);

  // Wine Data State
  const [wineData, setWineData] = useState([]);
  const [wineListData, setWineListData] = useState([]);
  const [wineEditId, setWineEditId] = useState("");

  const [dialog, setDialog] = useState({ dialog1: false, dialog2: false });
  const [selectedPair, setSelectedPair] = useState(null);

  const handlePDFDialog = (item, type) => {
    // Example: Open a new window with the selected type
    if (type === "nation") {
      window.open(`/wine_list_pdf/${item?.slug}?criteria=nation`, "_blank");
    } else if (type === "product_type") {
      window.open(`/wine_list_pdf/${item?.slug}?criteria=product_type`, "_blank");
    }

    setDialog(false); // Close the modal
  };

  const handleDeleteDialog = () => { };

  //================== common for stock and wine list ==================

  const getWineData = async (atr, searchData) => {
    setIsLoading({ ...isLoading, main: true });
    try {
      const params = {
        pageNumber: page,
        size: rowsPerPage,
        wineListId: wineStockAvailable && wineEditId,
      };
      if (atr === "search" || searchWine.length > 0) {
        params.search =
          atr === "search" ? searchData?.target?.value : searchWine;
      }
      let response;
      if (wineStockAvailable) {
        response = await axios.get(
          `${apiUrl}/api/v1/wine-stock/${slug2 || rest_slug2}`,
          {
            params,
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else {
        response = await axios.get(
          `${apiUrl}/api/v1/wines?forWineList=yes&restaurantId=${slug2 || rest_slug2
          }`,
          {
            params,
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      setWineData(response?.data?.data || []);
      setTotalPages(response.data?.total || 0);
    } catch (error) {
      console.error("Error fetching wine data:", error);
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const getRestData = async () => {
    axios
      .get(`${apiUrl}/api/v1/restaurants/${slug2 ? slug2 : rest_slug2}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setRestaurentDetail(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching restaurant data:", err);
      });
  };

  // const getWineListDataOld = async () => {
  //   try {
  //     setIsLoading({ ...isLoading, main: true });
  //     await axios.get(`${apiUrl}/api/v1/restaurants/${slug2 ? slug2 : rest_slug2}/winelists?pageNumber=1&size=10`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }).then((res) => {
  //       if (res.status === 200) {
  //         setWineListData(res?.data?.data);
  //       } else {
  //         setWineListData([]);
  //       }
  //     });
  //   } catch (err) {
  //     console.error("err:", err);
  //     setWineListData([]);
  //     setIsLoading({ ...isLoading, main: true });
  //   }
  // };

  const getWineListData = async () => {
    try {
      setIsLoading((prev) => ({ ...prev, main: true }));

      const params = {
        pageNumber: page2,
        size: rowsPerPage2,
      };

      const response = await axios.get(
        `${apiUrl}/api/v1/restaurants/${slug2 ? slug2 : rest_slug2}/winelists`,
        {
          params: params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const { data } = response;
        setWineListData(data?.data || []);
        setTotalPages2(data?.total || 0);
      } else {
        setWineListData([]);
      }
    } catch (err) {
      console.error("Error fetching wine list data:", err.message || err);
      setWineListData([]);
    } finally {
      setIsLoading((prev) => ({ ...prev, main: false }));
    }
  };

  const downloadQRCode = (slug) => {
    const svg = document.querySelector(`svg[qr-value="${slug}"]`);

    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      img.onload = () => {
        const desiredSize = 300;
        canvas.width = desiredSize;
        canvas.height = desiredSize;

        ctx.fillStyle = "#8b2433";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(img, 0, 0, desiredSize, desiredSize);

        const pngFile = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = pngFile;
        link.download = `${slug}-qr-code.png`;
        link.click();
      };

      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    } else {
      console.error("SVG QR code not found");
    }
  };

  const changeWineListStatus = async (e, id, status) => {
    e.preventDefault();
    setIsLoading({ ...isLoading, main: true });
    try {
      const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
      const response = await axios.put(
        `${apiUrl}/api/v1/winelists/${id}/status`,
        { status: status === "Active" ? "Inactive" : "Active" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      getWineListData();
      toast.success(response?.data?.message, {
        theme: "colored",
        autoClose: 1000,
      });
    } catch (error) {
      console.error("Error changing wine list status:", error);
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  const handleWineListDelete = async (id) => {
    if (!id) {
      console.error("Error: ID is required to delete a user.");
      return;
    }
    setIsLoading({ ...isLoading, main: true });
    try {
      const response = await axios.delete(`${apiUrl}/api/v1/winelists/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      getWineListData();
      toast.success(response?.data?.message || "Wines deleted successfully:", {
        theme: "colored",
        autoClose: 1000,
      });
    } catch (error) {
      console.error(
        "Error deleting dish:",
        error?.response?.data?.message || error.message
      );
      toast.error("Failed to delete the Wine. Please try again.", {
        theme: "colored",
        autoClose: 3000,
      });
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  useImperativeHandle(ref, () => ({
    restaurantWineList() {
      setAddWineList(false);
      setEditWineList(false);
      setWineEditId();
    },
  }));

  useEffect(() => {
    const role = localStorage.getItem("Role");
    setUserType(role);
  }, []);

  useEffect(() => {
    getWineData();
    // const storedData = JSON.parse(localStorage.getItem("searchTexts")) || {};
    // if (wineStockAvailable) {
    //   setSearchWine(storedData["WineList Stock Text"] || "");
    // } else {
    //   setSearchWine(storedData["WineList AllWines Text"] || "");
    // }
  }, [searchWine, page, rowsPerPage, wineStockAvailable]);

  useEffect(() => {
    getRestData();
    getWineListData();
  }, [slug2, rest_slug2, page2, rowsPerPage2]);

  useEffect(() => {
    const handlePageRefresh = () => {
      const searchTexts = JSON.parse(localStorage.getItem("searchTexts")) || {};
      delete searchTexts["WineList Stock Text"];
      delete searchTexts["WineList AllWines Text"];
      localStorage.setItem("searchTexts", JSON.stringify(searchTexts));
    };
    window.addEventListener("unload", handlePageRefresh);
    return () => {
      window.removeEventListener("unload", handlePageRefresh);
    };
  }, []);

  return (
    <>
      {
        <section className="border-t border-[#D9D9D9] mt-5 pt-10">
          {addWineList ? (
            <WineListAdd
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              setPage={setPage}
              wineData={wineData}
              setWineData={setWineData}
              wineStockAvailable={wineStockAvailable}
              setWineStockAvailable={setWineStockAvailable}
              getWineData={getWineData}
              getWineListData={getWineListData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setAddWineList={setAddWineList}
              searchWine={searchWine}
              setSearchWine={setSearchWine}
              handleSearchChange={handleSearchChange}
            />
          ) : editWineList ? (
            <WineListEdit
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              page={page}
              setPage={setPage}
              wineData={wineData}
              setWineData={setWineData}
              wineEditId={wineEditId}
              setWineEditId={setWineEditId}
              editWineList={editWineList}
              setEditWineList={setEditWineList}
              wineStockAvailable={wineStockAvailable}
              setWineStockAvailable={setWineStockAvailable}
              getWineData={getWineData}
              getWineListData={getWineListData}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              searchWine={searchWine}
              setSearchWine={setSearchWine}
              handleSearchChange={handleSearchChange}
            />
          ) : (
            <>
              <section>
                <div className="flex lg:flex-row flex-col justify-between items-center">
                  <h3
                    className="self-start text-3xl cursor-pointer font-bold mb-2 poppins-medium"
                    onClick={() =>
                      navigate(`/restaurant/${restaurentDetail?.slug}`)
                    }
                  >
                    Le carte vino di{" "}
                    <span className="hover:underline">
                      {restaurentDetail?.restaurant_name
                        ? restaurentDetail?.restaurant_name
                        : "-"}
                    </span>
                  </h3>
                  <div className="self-start flex items-center gap-4 sm:flex-row flex-col sm:w-auto w-full">
                    {hasPermission("WineList", "add") && (
                      <>
                        <button
                          className="md:w-auto text-center w-full self-start flex items-center justify-center px-2 py-1 bg-[#8A2533] text-white rounded-lg border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                          onClick={() => {
                            setAddWineList(true);
                          }}
                        >
                          <FaPlus />
                          <span className="ml-2 poppins-regular">
                            Aggiungi Nuova Carta Vino
                          </span>
                        </button>
                      </>
                    )}
                  </div>
                </div>
                <div className="dash-table-main  w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow mt-5">
                  <table className="w-full text-left wine_table">
                    <thead>
                      <tr className="border-b border-[#8B2433]">
                        <th className="pb-3 text-left poppins-medium text-[#6B6B6B]">
                          Nome
                        </th>
                        {hasPermission("WineList", "edit") ? (
                          <th className="pb-3 text-left poppins-medium text-[#6B6B6B]">
                            Stato
                          </th>
                        ) : (
                          <th className="pb-3 text-left poppins-medium text-[#6B6B6B]"></th>
                        )}
                        <th className="pb-3 text-left poppins-medium text-[#6B6B6B] w-[12%]">
                          Opzioni
                        </th>
                      </tr>
                    </thead>
                    {isLoading?.main ? (
                      <TableLoader />
                    ) : (
                      <tbody>
                        {wineListData && wineListData?.length > 0 ? (
                          wineListData?.map((item, index) => (
                            <tr
                              key={index}
                              className="border-b border-[#8B2433]/12"
                            >
                              <td className="text-left md:w-auto sm:w-[260px] w-[170px] poppins-medium text-[#303030] py-4">
                                {item?.name || "N/A"}
                              </td>
                              {hasPermission("WineList", "edit") ? (
                                <td className="text-start py-4">
                                  <label className="m-auto inline-flex items-center cursor-pointer">
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        changeWineListStatus(
                                          e,
                                          item?.id,
                                          item?.status
                                        )
                                      }
                                      checked={item?.status === "Active"}
                                      className="sr-only peer accent-[#8B2433]"
                                    />
                                    <div
                                      className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                               peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                                after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all peer-checked:bg-[#8B2433]"
                                    ></div>
                                  </label>
                                </td>
                              ) : (
                                <td className="text-start py-4"></td>
                              )}
                              <td className="text-start py-4 flex gap-4 w-full items-center h-[70px]">
                                <button
                                  onClick={() =>
                                    navigate(
                                      `/restaurant/${restaurentDetail?.slug}/wine-list/${item?.slug}?priceType=${item?.price_type_filter}&&priceFilter=${item?.price_filter}`
                                    )
                                  }
                                >
                                  <FaLink color="#8B2433" size={"18px"} />
                                </button>

                                <Menu>
                                  <MenuButton><BsThreeDotsVertical color="#8B2433" size={"18px"} /></MenuButton>
                                  <MenuItems anchor="bottom" className="bg-[#fffbfb] w-[210px] border text-black py-0 flex flex-col  shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden">
                                    {/* Arrow at the top */}
                                    <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white"></div>
                                    <MenuItem className="flex gap-2 justify-start items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                      <div className="w-full">
                                        <QRCode
                                          className="hidden"
                                          value={`${frontendApiUrl}restaurant/${restaurentDetail?.slug}/wine-list/${item?.slug}?qrcode=true`}
                                          bgColor="transparent"
                                          fgColor="white"
                                          size={50}
                                          qr-value={item?.slug}
                                        />
                                        <button
                                          onClick={() => downloadQRCode(item?.slug)}
                                          className="w-full text-left flex gap-2 items-center"
                                        >
                                          <IoQrCode size={"18px"} className="flex-shrink-0" />
                                          <span className="whitespace-normal">Scarica Codice QR</span>
                                        </button>
                                      </div>
                                    </MenuItem>

                                    <MenuItem className="flex gap-2 justify-start border-t items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                      <button
                                        onClick={() => {
                                          setDialog({
                                            ...dialog,
                                            dialog1: true,
                                          });
                                          setSelectedPair(item);
                                        }}
                                        className="w-full text-left flex gap-2 items-center overflow-hidden text-ellipsis"
                                      >
                                        <MdSaveAlt size={"18px"} className="flex-shrink-0" />
                                        <span className="whitespace-normal">Scarica Carta Vini</span>
                                      </button>
                                    </MenuItem>

                                    {hasPermission("WineList", "edit") && (
                                      <MenuItem className="flex gap-2 justify-start border-t items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                        <button
                                          onClick={() => {
                                            setEditWineList(true);
                                            setWineEditId(item?.id);
                                            setPage(1);
                                            setRowsPerPage(10);
                                          }}
                                          className="w-full text-left flex gap-2 items-center whitespace-nowrap overflow-hidden text-ellipsis"
                                        >
                                          <TbEdit size={"18px"} className="flex-shrink-0" />
                                          <span>Modifica</span>
                                        </button>
                                      </MenuItem>
                                    )}

                                    {hasPermission("WineList", "remove") && (
                                      <MenuItem className="flex gap-2 justify-start border-t items-center poppins-regular px-3 py-2 hover:bg-[#8b2532] hover:text-[#fff] transition-all duration-300 ease-in-out">
                                        <button className="w-full text-left flex gap-2 items-center whitespace-nowrap overflow-hidden text-ellipsis"
                                          onClick={() => {
                                            setDialog({
                                              ...dialog,
                                              dialog2: true,
                                            });
                                            setSelectedWineListId(item?.id);
                                          }}
                                        >
                                          <BiSolidTrashAlt size={"18px"} className="flex-shrink-0" />
                                          <span>Elimina</span>
                                        </button>
                                      </MenuItem>
                                    )}
                                  </MenuItems>
                                </Menu>
                                {/* Modal (rendered outside the button) */}
                                {dialog?.dialog1 && (
                                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                    <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px] relative">
                                      <button
                                        onClick={() =>
                                          setDialog({
                                            ...dialog,
                                            dialog1: false,
                                          })
                                        }
                                        className="absolute top-2 right-2 p-1 text-gray-500 hover:text-gray-700 transition-colors"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-6 w-6"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M6 18L18 6M6 6l12 12"
                                          />
                                        </svg>
                                      </button>

                                      <div className="px-6 py-4 border-b">
                                        <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                          Come vorresti organizzare la carta?
                                        </h3>
                                      </div>
                                      <div className="px-6 py-4 flex justify-end space-x-4">
                                        <button
                                          onClick={() =>
                                            handlePDFDialog(
                                              selectedPair,
                                              "nation"
                                            )
                                          }
                                          className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                        >
                                          Nazione
                                        </button>
                                        <button
                                          onClick={() =>
                                            handlePDFDialog(
                                              selectedPair,
                                              "product_type"
                                            )
                                          }
                                          className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                        >
                                          Tipologia
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {dialog?.dialog2 && (
                                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                                    <div className="bg-white rounded-lg shadow-lg sm:w-1/3 w-[280px]">
                                      <div className="px-6 py-4 border-b">
                                        <h3 className="text-lg font-semibold text-gray-800 poppins-medium">
                                          Are you sure you want to delete the
                                          Wine List?
                                        </h3>
                                      </div>
                                      <div className="px-6 py-4 flex justify-end space-x-4">
                                        <button
                                          onClick={() => {
                                            handleWineListDelete(
                                              selectedWineListId
                                            );
                                            setDialog({
                                              ...dialog,
                                              dialog2: false,
                                            });
                                          }}
                                          className="px-4 py-2 poppins-regular bg-[#8A2533] text-white rounded-md hover:bg-[#f6efef] hover:text-[#8A2533] transition-colors"
                                        >
                                          Yes
                                        </button>
                                        <button
                                          onClick={() =>
                                            setDialog({
                                              ...dialog,
                                              dialog2: false,
                                            })
                                          }
                                          className="px-4 py-2 poppins-regular bg-gray-300 text-gray-700 rounded-md hover:text-white hover:bg-[#8A2533] transition-colors"
                                        >
                                          No
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} className="text-center py-10">
                              Nessuna lista dei vini trovata
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </section>
            </>
          )}

          <div className="text-center items-center flex justify-center m-2 mt-6">
            {userType === "admin" &&
              addWineList === false &&
              editWineList === false && (
                <button
                  className="flex items-center px-2 py-1 bg-[#8A2533] text-white rounded-lg border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                  onClick={() => {
                    navigate("/admin/restaurantManagement");
                  }}
                >
                  <IoIosArrowBack
                    size={"25px"}
                    color="white"
                    className="group-hover:invert"
                  />
                  <span className="ml-2 poppins-regular">Torna indietro</span>
                </button>
              )}
          </div>
        </section>
      }
    </>
  );
};

export default forwardRef(WineListManagement);
